export const CONVERSATIONS_PAGE_SIZE = 20;

/**
 * Upper bound on how many conversations the header dropdown accumulates via infinite scroll.
 * Beyond this, "View All Chats" is the intended path rather than an unbounded in-memory list.
 */
export const MAX_DROPDOWN_CONVERSATIONS = 100;
